import SimpleLightbox from 'simplelightbox';

const productPage = {
    init() {
        this.setProductGallery();
    },
    setProductGallery() {
        const images = document.querySelectorAll('.woocommerce-product-gallery__wrapper a');

        if ( ! images.length ) return;

        new SimpleLightbox(images);
    }
}

if (document.readyState === 'loading') { 
    document.addEventListener('DOMContentLoaded', () =>  productPage.init()); 
  } else { 
     productPage.init();
}
